// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__je1CG","label":"Checkbox_label__n8n2z","input":"Checkbox_input__U4fKq","icon":"Checkbox_icon__X-NWz"};